import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent extends DestructorComponent implements OnInit {
  headerMenu: any[] = [];
  user: any;

  constructor(private router: Router, private _globalStateService:GlobalStateService) {
    super();
  }

  ngOnInit() {
    // Subscribe to user changes
    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;
        this.generateHeaderMenu();
      })
    );
  }

  generateHeaderMenu() {
    const excludedPaths = ['login', 'register', '2fa', 'reset', '403', 'profile']; // <- paths to exclude

    this.headerMenu = this.router.config
      .filter(route =>
        route.data?.navTitle && !excludedPaths.includes(route.path || '')
      )
      .map(route => ({
        title: route.data?.navTitle,
        link: `/${route.path}`
      }));

      if(this.user?.role_type === 20) {

        console.log("User is client:", this.user);

        this.headerMenu = this.headerMenu.filter(menu => {
          return menu.link == '/bid-manager' || menu.link == '/dashboard';
        });

      }
    }
}
